import useMutationApi from '../useMutationApi';

export enum SupplierStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  ON_HOLD = 'on_hold',
}

interface CreateSupplierData {
  name: string;
  contact_name?: string;
  email?: string;
  phone?: string;
  status: SupplierStatus;
  metadata?: {
    [key: string]: unknown;
  } | null;
}

interface CreateSupplierResponse {
  id: string;
  name: string;
  contact_name: string | null;
  email: string | null;
  phone: string | null;
  status: string;
  metadata: {
    [key: string]: unknown;
  } | null;
}

const useCreateSupplier = (onSuccess?: () => void) => {
  return useMutationApi<CreateSupplierData, CreateSupplierResponse>({
    endpoint: 'accounts-payable/suppliers',
    method: 'POST',
    options: {
      onSuccess,
    },
    successMessage: 'Supplier created successfully',
  });
};

export default useCreateSupplier;
